import { showErrorToast } from '@amigoapp/doca-react';
import { createAttendance } from '../processes/attendance';
import { LINK_EXPIRED_MESSAGE, isScheduleLinkError } from './linkSession';

export const LINK_EXPIRED_PATH = '/link-expired';

export const createAttendanceWithLink = async ({ attendanceData, scheduleLinkCode, setAnswer, history }) => {
	const { data, error } = await createAttendance({ ...attendanceData, schedule_link_code: scheduleLinkCode });

	const linkError = isScheduleLinkError(error, scheduleLinkCode);

	if (linkError) {
		showErrorToast(LINK_EXPIRED_MESSAGE);
		history?.replace(LINK_EXPIRED_PATH);
	}

	if (scheduleLinkCode && !error) {
		setAnswer('schedule_link_code', null);
	}

	return { data, error, linkError };
};
